import { Bl_inv_stock_replenishment_event_filter_supplier_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class StockReplenishmentEventFilterSupplierModel extends BaseContainerModel {
  bl_inv_stock_replenishment_event_filter_supplier: Bl_inv_stock_replenishment_event_filter_supplier_RowClass = new Bl_inv_stock_replenishment_event_filter_supplier_RowClass();
}
